import { useEffect } from 'react';
import { useRouter } from 'shared-routing';

import { EDIT_DATES_QUERY } from './constants';
import { openJourneyPickerDates } from './openJourneyPickerDates';

export function useOpenDatesFromQuery() {
  const router = useRouter();
  const isRequested = !!router.query[EDIT_DATES_QUERY];

  useEffect(() => {
    if (!isRequested) return;

    openJourneyPickerDates();

    const query = { ...router.query };
    delete query[EDIT_DATES_QUERY];
    router.replace({ pathname: router.pathname, query }, undefined, { shallow: true });
  }, [isRequested, router]);
}
